import LockedJob from '@components/icons/LockedJob.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useModalContext } from '@providers/ModalProvider';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { AdminJobTopActionButton } from '@components/core-ui/form-elements/buttons/Button/variations/AdminJobTopActionButton';

export const ChangeUnlockTypeButton = () => {
  const { job, manualReload } = usePageContext();
  const { openModal, closeModal } = useModalContext();

  if (!job) {
    return null;
  }

  const openUnlockModal = () => {
    openModal(ModalNamesEnum.AdminEditJobTranscriptUnlockType, {
      jobId: job.id,
      initialValue: job.transcriptUnlockType,
      onSuccess: () => {
        manualReload();
        closeModal();
      },
    });
  };

  return (
    <AdminJobTopActionButton title="Change Transcript Unlock Type" onClick={openUnlockModal} className="min-w-[140px]">
      <LockedJob />
      Change Unlock Type
    </AdminJobTopActionButton>
  );
};
